import styled from "@emotion/styled/macro";
import {
  Modal,
  Select,
  Typography,
  tokens,
} from "@sunrun/experience-ui-components";
import { useState } from "react";
import { CANCEL_BODY_REMEMBER } from "./constants";

type SiteSurveyCancelAppointmentModalProps = {
  testId: string;
  cancellationReasonSelectTestId: string;
  loadingOverlayTestId: string;
  cancellationReasons: Array<{ label: string; value: string }>;
  bodyLine1: string;
  onSubmit: (reason: string) => void;
  onClose: () => void;
  loading?: boolean;
};

const SiteSurveyCancelAppointmentModal: React.FC<
  SiteSurveyCancelAppointmentModalProps
> = ({
  testId,
  cancellationReasonSelectTestId,
  loadingOverlayTestId,
  loading,
  cancellationReasons,
  onSubmit,
  onClose,
  bodyLine1,
}) => {
  const [reason, setReason] = useState(cancellationReasons[0]?.value ?? "");

  return (
    <Modal
      testId={testId}
      hideIcon
      onClose={onClose}
      secondaryButton={{
        text: "Keep Appointment",
        onClick: onClose,
      }}
      primaryButton={{
        text: "Cancel Appointment",
        onClick: () => onSubmit(reason),
      }}
      title="Are you sure?"
    >
      <Typography color={tokens.BRAND_HERO_BLUE}>{bodyLine1}</Typography>
      <Typography color={tokens.BRAND_HERO_BLUE}>
        {CANCEL_BODY_REMEMBER}
      </Typography>
      <Label color={tokens.TINTS_OFF_WHITE_20}>Cancellation Reason</Label>
      <Select
        data-testid={cancellationReasonSelectTestId}
        options={cancellationReasons}
        onChange={(e) => {
          setReason(e.target.value);
        }}
        value={reason}
      />
      {loading && <LoadingOverlay data-testid={loadingOverlayTestId} />}
    </Modal>
  );
};

const Label = styled(Typography)`
  && {
    margin-top: 26px;
    margin-bottom: 6px;
    font-size: 14px;
  }
`;

const LoadingOverlay = styled.div`
  cursor: progress;
  position: absolute;
  background: white;
  opacity: 0.5;
  margin-left: -40px;
  width: 100%;
  height: 134px;
  border-radius: 50%;
`;

export { SiteSurveyCancelAppointmentModal };
export type { SiteSurveyCancelAppointmentModalProps };
